<script setup lang="ts">
import Button from 'primevue/button';

const emits = defineEmits<{ callProcess: [] }>();

const processPricing = () => {
  emits('callProcess');
};
</script>
<template>
  <div>
    <Button id="process-pricing-btn" size="small" severity="danger" class="custom-button" :label="$t('common.buttons.process')" @click="processPricing()" />
  </div>
</template>
